<template>
  <div>
    <v-app class="app-tabela">
      <!-- TABS -->
      <b-tabs
        v-model="tabAtiva"
        content-class="mt-3"
        class="esus-feedback-tabs tabs-auto"
      >
        <b-tab title="Odontológicos" />
        <b-tab title="Outros" />
      </b-tabs>

      <v-card class="tabela">
        <v-card-title>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar"
            class="input-bottom"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>

        <v-data-table
          @pagination="getPagination"
          :page="currentPage"
          :footer-props="{
            itemsPerPageText: '',
            'items-per-page-options': [10],
            'disable-items-per-page': true,
          }"
          :loading="loading"
          loading-text="Carregando, Por favor espere"
          :headers="headers"
          :items="indexedItems"
          :search="search"
          item-key="index"
          class="elevation-1"
          :single-expand="true"
          :expanded.sync="expanded"
          show-expand
          @item-expanded="onItemExpanded"
        >
          <template v-slot:expanded-item="{ headers, item }">
            <td colspan="9">
              <table class="table table-interna table-interna-acompanhamento">
                <thead>
                  <tr>
                    <th>CFCP</th>
                    <th>CPF</th>
                    <th>CNS</th>
                    <th>Unidade de saúde</th>
                    <th>Profissional</th>
                    <th>T. Registro</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{ item.cfcp }}</td>
                    <td>{{ item.cpf }}</td>
                    <td>{{ item.cns }}</td>
                    <td>{{ item.unidade_saude }}</td>
                    <td>{{ item.profissional }}</td>
                    <td>{{ item.tipo_registro }}</td>
                  </tr>
                </tbody>
              </table>

              <b-alert
                v-if="item.duplicadoInfo"
                variant="danger"
                show
                class="mt-2"
              >
                Registro duplicado. Tem outro atendimento na data
                {{ item.duplicadoInfo.data }}
                com esse mesmo Identificador (Id {{ item.duplicadoInfo.id }}).
                Recomenda-se realizar auditoria no Banco de Dados.
              </b-alert>

              <b-alert
                v-if="item.dt_nascimento != cidadao.dt_nascimento"
                variant="danger"
                show
                class="mt-4"
              >
                A data de nascimento registrada nesse atendimento
                {{
                  item.dt_nascimento != null
                    ? formatDate(item.dt_nascimento)
                    : ''
                }}
                é diferente da data de nascimento atual do cidadão
                {{
                  cidadao.dt_nascimento != null
                    ? formatDate(cidadao.dt_nascimento)
                    : ''
                }}.
              </b-alert>
            </td>
          </template>

          <template v-slot:[`footer.page-text`]="items">
            <div class="info-table-item tabela-esus-pec">
              <FonteSincronizadorC />
            </div>
            <span class="paginacao"
              >{{ items.pageStart }} - {{ items.pageStop }} de
              {{ items.itemsLength }} registros</span
            >
          </template>

          <template v-slot:no-data>
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada.</b>
            </div>
          </template>

          <template v-slot:no-results style="padding: 0px">
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada.</b>
            </div>
          </template>

          <template v-slot:item.dt_procedimento="{ item }">
            <td>
              {{
                item.dt_procedimento != null
                  ? formatDate(item.dt_procedimento)
                  : ''
              }}
            </td>
          </template>
        </v-data-table>
      </v-card>
    </v-app>
  </div>
</template>

<script>
import utils from '@/mixins/utils.js'

export default {
  name: 'Procedimentos',
  props: {
    cidadao: { type: Object, default: () => null },
    filtroAtendimento: {
      type: Object,
      default: () => ({ filtro: null, operador: '>=', data: '' }),
    },
    cnsList: { type: Array, default: () => [] },
  },
  mixins: [utils],
  data() {
    return {
      tabAtiva: 0, // 0 = Odontológicos, 1 = Outros
      expanded: [],
      headers: [
        {
          text: 'ID',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'id',
        },
        {
          text: 'DATA',
          align: 'start',
          filterable: false,
          sortable: true,
          value: 'dt_procedimento',
        },
        {
          text: 'SIGTAP',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'co_proced',
        },
        {
          text: 'PROCEDIMENTO',
          align: 'start',
          filterable: false,
          sortable: true,
          value: 'ds_proced',
        },
        { text: '', value: 'data-table-expand' },
      ],
      cadastrosOriginais: [],
      cadastros: [],
      currentPage: 1,
      search: '',
      loading: false,
      periodos: [
        { label: 'Últimos 13 meses', value: 13 },
        { label: 'Últimos 36 meses', value: 36 },
      ],
      periodo: null,
    }
  },
  mounted() {
    this.buscarDados()
  },
  computed: {
    cadastrosPorAba() {
      const lista = this.cadastros

      if (this.tabAtiva === 0) {
        // Odontológicos (st_proced_odonto == 1)
        return lista.filter((item) => item.st_proced_odonto == 1)
      }

      // Outros
      return lista.filter((item) => item.st_proced_odonto != 1)
    },

    cadastrosFiltrados() {
      const { operador, data, usarFiltroData } = this.filtroAtendimento || {}

      // sem filtro ativo
      if (!usarFiltroData || !data || !operador) {
        return this.cadastrosPorAba
      }

      return this.cadastrosPorAba.filter((item) => {
        const dataItem = item.dt_procedimento.split('/').reverse().join('-')
        return this._compareDates(dataItem, data, operador)
      })
    },

    indexedItems() {
      return this.cadastrosFiltrados.map((item, index) => {
        const tipo_registro =
          item.tp_registro != null
            ? String(item.tp_registro).replace(/[{}]/g, '')
            : ''

        return {
          index,
          tipo_registro,
          ...item,
        }
      })
    },
  },
  methods: {
    /**
     * Atualiza a página atual da tabela.
     * @param {Object} options Dados da paginação
     */
    getPagination(options) {
      this.currentPage = options.page
    },

    /**
     * Compara duas datas no formato YYYYMMDD.
     * @param {String} aYmd Primeira data
     * @param {String} bYmd Segunda data
     * @param {String} op Operador de comparação
     * @returns {Boolean}
     */
    _compareDates(aYmd, bYmd, op) {
      if (!aYmd || !bYmd) return true
      switch (op) {
        case '>':
          return aYmd > bYmd
        case '<':
          return aYmd < bYmd
        case '>=':
          return aYmd >= bYmd
        case '<=':
          return aYmd <= bYmd
        case '=':
          return aYmd === bYmd
        default:
          return true
      }
    },

    /**
     * Calcula a diferença em meses entre a data informada e hoje.
     * @param {String} date Data no formato YYYY-MM-DD
     * @returns {Number} Quantidade de meses
     */
    diffMonthsFromDate(date) {
      const [year, month, day] = date.split('-')
      const startDate = new Date(year, month - 1, day)
      const today = new Date()
      let months = (today.getFullYear() - startDate.getFullYear()) * 12
      months -= startDate.getMonth()
      months += today.getMonth()
      return months
    },

    /**
     * Filtra os cadastros pelo período informado.
     * @param {Object|null} periodo Período selecionado
     */
    handlePeriod(periodo) {
      if (periodo == null) {
        this.cadastros = this.cadastrosOriginais
        return
      }
      this.cadastros = this.cadastrosOriginais.filter((item) => {
        const itemDate = item.dt_procedimento
        const monthsDiff = this.diffMonthsFromDate(itemDate)
        return monthsDiff <= periodo.value
      })
    },

    /**
     * Busca os dados
     */
    async buscarDados() {
      try {
        this.loading = true
        const response2 = await this.$api.post(`/app/cidadao/procedimentos`, {
          co_ibge: this.$store.state.cod_ibge,
          cpf: this.cidadao.nu_cpf,
          cns: this.cnsList,
        })
        if (response2) {
          this.cadastrosOriginais = response2.data
          this.cadastros = response2.data
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },

    /**
     * Manipula o evento de expansão de um item da tabela.
     * @param {Object} ctx Contexto do item expandido
     */
    onItemExpanded(ctx) {
      const item = ctx?.item

      if (!item) return

      const duplicados = this.indexedItems.filter((i) => i.id === item.id)
      if (duplicados.length >= 2) {
        this.$set(item, 'duplicadoInfo', {
          data: item.dt_atendimento ? this.formatDate(item.dt_atendimento) : '',
          id: item.id,
        })
      } else {
        this.$delete(item, 'duplicadoInfo')
      }
    },
  },
}
</script>
